import { useState, useRef, useCallback, useEffect } from "react";
import { obtenerDatosTemporisApi } from "../../api/listas/temporisApi";
import { useUnidadRolTemporis } from "../../hooks/datosLaborales";
import { getNumerosEnCadena_2 } from "../../utils/funciones";
import { mensajeSimple } from "../../components/ui/sweetAlerts";

export const useCambioUnidad = () => {
  const [arrTemporis, setArrTemporis] = useState([]);
  const [arrPlanHorario, setArrPlanHorario] = useState([]);

  const { actualizarRolTemporis } = useUnidadRolTemporis();
  const debounceTimerRef = useRef(null);

  const fetchTemporisData = async (local_codigo_erp, numero_plan_horario) => {
    try {
      const temporis = await obtenerDatosTemporisApi(local_codigo_erp, numero_plan_horario);
      setArrPlanHorario(temporis?.data || []);

      if (!temporis?.data || temporis.data.length === 0) {
        mensajeSimple("info", "No se encontraron planes de horario para este cargo", 3000);
        setArrTemporis([]);
        return;
      }

      const arr = (temporis.unidad_organizativa_rol_temporis || []).map((el) => ({
        label: `${el.Unidadorganizativa} - ${el.Cargogenericonombre}`,
        value: el,
      }));

      setArrTemporis(arr);
    } catch (error) {
      console.error("Error al obtener datos de Temporis:", error);
    }
  };

  const setTemporis = useCallback((obj) => {
    if (!obj) return;

    actualizarRolTemporis("cod_sap_nuevo_cargo");
    let numero_plan_horario = "";
    let local_codigo_erp = "";

    if (typeof obj === "object") {
      numero_plan_horario = getNumerosEnCadena_2(obj["REEO_PLAN_HORARIO"]);
      local_codigo_erp = obj["REEO_COD_SUB_DIVISION"];
    }

    let obj_ = "";
    if (typeof obj === "string") {
      try {
        obj_ = JSON.parse(obj);
      } catch (e) {
        obj_ = "";
      }
    }

    if (obj_) {
      numero_plan_horario = getNumerosEnCadena_2(obj_["MOES_DESCRIPCION_POSICION"]);
      local_codigo_erp = obj_["MOES_COD_SUB_DIVISION"];
    }

    if (!local_codigo_erp) return;

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      fetchTemporisData(local_codigo_erp, numero_plan_horario);
    }, 300);
  }, []);

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  return {
    setTemporis,
    arrTemporis,
    arrPlanHorario,
  };
};